// Comment ça marche : trois temps reliés par un fil pointillé, chacun avec sa
// durée et sa vignette dessinée en CSS. Pas de cartes : des colonnes.
import { useT } from '../../lib/i18n'
import { Lock, Phone } from './Icons'

function Vis ({ kind }) {
  const v = useT().how.vis
  if (kind === 'account') {
    return (
      <div className="lp-vis lp-vis--form">
        <span className="lp-vis__fld"><i>Email</i>{v.email}</span>
        <span className="lp-vis__fld"><i>Password</i>{v.pass}</span>
        <span className="lp-vis__btn">{v.btn}</span>
      </div>
    )
  }
  if (kind === 'lock') {
    return (
      <div className="lp-vis lp-vis--lock">
        <span className="lp-vis__qr" aria-hidden="true">
          {Array.from({ length: 49 }, (_, i) => <i key={i} className={((i * 7) % 5 < 3 || i % 8 === 0) ? 'on' : ''} />)}
        </span>
        <span className="lp-vis__dev">
          <Phone />
          <span><b>iPhone 15</b><small>{v.profile}</small></span>
          <em><Lock />{v.locked}</em>
        </span>
      </div>
    )
  }
  return (
    <div className="lp-vis lp-vis--live">
      <span className="lp-vis__day">{v.day(21)}</span>
      <span className="lp-vis__days">
        {Array.from({ length: 28 }, (_, i) => <i key={i} className={i < 21 ? 'on' : ''} />)}
      </span>
      <span className="lp-vis__streak">{v.streak}</span>
    </div>
  )
}

export default function How () {
  const h = useT().how
  return (
    <section className="lp-sec" id="how">
      <div className="lp-wrap">
        <div className="lp-split-head lp-rv">
          <div>
            <span className="lp-kicker">{h.kicker}</span>
            <h2 className="lp-h2">{h.title}</h2>
          </div>
          <p className="lp-lead">{h.lead}</p>
        </div>

        <ol className="lp-steps">
          {h.steps.map((s, i) => (
            <li className="lp-step lp-rv" key={s.t}>
              <div className="lp-step__top">
                <span className="lp-step__n">{String(i + 1).padStart(2, '0')}</span>
                <span className="lp-step__time">{s.time}</span>
              </div>
              <div className="lp-step__vis"><Vis kind={s.vis} /></div>
              <h3 className="lp-step__t">{s.t}</h3>
              <p className="lp-step__p">{s.p}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  )
}
